//import 'es6-promise/auto'
import axios from 'axios'
import store from '../store';
import Vue from 'vue';

// create an axios instance

function getKey() {
    return store.getters.sessionKey;
}

function getPassword() {
    return store.getters.sessionToken;
}


const service = axios.create({
    baseURL: '/api/v1/',//process.env.baseUrl,
    //baseURL: process.env.baseUrl,
    timeout: 120000, // request timeout
    responseType: 'json',
    headers: {
        "Content-Type": "application/json",
        'Pragma': 'no-cache',
        'Cache-Control': 'no-cache,no-store',
    },
});

service.interceptors.request.use(config => {  // Do something before request is sent
    config.headers.s = getKey();
    config.headers.j = getPassword();
    config.headers.t = Math.round(new Date().getTime() / 1000),
    config.headers['Content-Type'] = 'application/json';
    if (config._loadingMessage) {   
        store.dispatch('changeLoadingStatusWithMessage', {status: true, message: config._loadingMessage});
    } else {
        store.dispatch('changeLoadingStatus', true);
    }
    return config
}, error => {
    store.dispatch('changeLoadingStatus', false);
    // Do something with request error
    Promise.reject(error);
});

// respone interceptor
service.interceptors.response.use(
    response => {
        //alert(store.getters.sessionToken);
        if (response.data.error != null) {
            if (response.data.error.code === "20005" && response.data.error.sub_code === "2") {
                store.dispatch('sentApp', {
                    action: "tokenExpired",
                    payload: {}
                });
                store.dispatch('changeLoadingStatus', false);
            } else if (response.data.error.code === "20005" || (response.data.error.code === "10000" && response.data.error.sub_code === "11")) {
                store.dispatch('sentApp', {
                    action: "sessionIsNull",
                    payload: {}
                });
                store.dispatch('changeLoadingStatus', false);
            } else if (response.data.error.code === '20000' && response.data.error.sub_code === '80927') {
                store.dispatch('changeLoadingStatus', false);
                store.dispatch('setLockBack', true);
                const vm = new Vue();
                return new Promise((resolve, reject) => {
                    vm.$confirm.require({
                        message: '目前連線至合作繳費系統人數眾多，可能需要較長等待時間，或請您稍後再使用。',
                        header: '系統忙碌中',
                        icon: 'pi',
                        acceptLabel: '繼續等待',
                        rejectLabel: '稍後再繳',
                        accept: () => {
                            store.dispatch('changeLoadingStatusWithMessage', {status: true, message: '處理中\n請勿進行其他操作'});
                            store.dispatch('setLockBack', false);
                            setTimeout(() => {
                                let originalRequest = response.config;
                                originalRequest._retry = true;
                                originalRequest._loadingMessage = '處理中\n請勿進行其他操作';
                                service(originalRequest).then(resolve).catch(reject);
                            }, 5000);                        
                        },
                        reject: () => {
                            store.dispatch('setLockBack', false);
                            window.location.href = '/bill/index.html';
                        }
                    });
                });
            } else {
                store.dispatch('changeLoadingStatus', false);
                return response.data;
            }
        } else {
            store.dispatch('changeLoadingStatus', false);
            return response.data;
        }
    }
    , error => {
        return Promise.reject(error);
    });



export default service

